export const reducerName = 'JOBS_FILTERS'

const ActionTypes = {
  SET_JOBS_FILTERS_TEXT_SEARCH: 'SET_JOBS_FILTERS_TEXT_SEARCH',
}

const initialState = {
  textSearch: '',
}

const JobsFiltersReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_JOBS_FILTERS_TEXT_SEARCH:
      return {
        ...state,
        textSearch: action.textSearch,
      }

    default:
      return state
  }
}

export const selectTextSearch = state => state?.[reducerName]?.textSearch
const setTextSearchAction = (textSearch) => ({
  type: ActionTypes.SET_JOBS_FILTERS_TEXT_SEARCH,
  textSearch: textSearch,
})

export const setTextSearch = (textSearch) => (dispatch) => {
  dispatch(setTextSearchAction(textSearch))
}

export const getInitialState = () => initialState

export const namedReducer = {[reducerName]: JobsFiltersReducer}
